import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import SettingSidebar from '../layouts/SettingsSidebar'
import Header from '../layouts/Header'
import Sidebar from '../layouts/Sidebar'
import axios from "../api/axios";
import { useFormik } from "formik";
import {  Apitoken, Authtoken } from "../Global";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const ChangePassword = () => {

    const [menu, setMenu] = useState(false)
    const [backendErrors, setBackendErrors] = useState([]);
    // const [backendSuccess, setBackendSuccess] = useState(null);




    const {
        values,
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
      } = useFormik({
        initialValues: {
   
            password: "",
            current_password: "",
          password_confirmation: "",
   
        },
        onSubmit: (values, actions) => {
          axios
            .post("/change-password", values, {
              headers: { Authorization: `Bearer ${Authtoken}`, Apitoken: Apitoken },
            })
            .then((response) => {
              delete backendErrors['error'];
              actions.setSubmitting(false);
              setBackendErrors([]);
              if (response.data.code === 200) {
                    //setBackendSuccess(response.data.message);
                    toast.success(response.data.message);
                    actions.resetForm();
                    setTimeout(() => {
                    window.location.href = "/change-password";
                    }, 1000);
                } 
                else if (response.data.code === 205) {
                setBackendErrors(response.data.error);
                }else if (response.data.code === 422) {
                    setBackendErrors(response.data.error);
                }
              
              else if (response.data.code === 401) {
                setBackendErrors(response.data.error);
              }
              else {
                 setBackendErrors(response.data.error);
              }
    
            })
            .catch((error) => {
                console.log(error);
              actions.setSubmitting(false);
            });
        },
      });
    
      const customHandleInput = (event) => {
        const Input_name = event.target.name;
        delete backendErrors[Input_name];
      };
      
	const toggleMobileMenu = () => {
		setMenu(!menu)
    }
        return (
           
            <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}> 
          
                <Header onMenuClick={() => toggleMobileMenu()} />
                <Sidebar />   <ToastContainer />
                <div className="page-wrapper">
                    <div className="content container-fluid">
                        <div className="page-header">
                            <div className="row">
                                <div className="col-sm-6">
                                    <h3 className="page-title">Settings</h3>
                                    <ul className="breadcrumb">
                                        <li className="breadcrumb-item"><Link to="/profile">Profile</Link>
                                        </li>
                                        <li className="breadcrumb-item active">Change Password</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    
                        <div className="row">
                            <div className="col-xl-2 col-md-3">
                                <SettingSidebar />    
                            </div>
                            
                            <div className="col-xl-10 col-md-9">
    
                                <div className="card">
                                    <div className="card-header">
                                        <h5 className="card-title">Change Password</h5>
                                    </div>
                                    <div className="card-body">
                                    
                                        <form action="#" onSubmit={handleSubmit}>
                                         <div className="row">


                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label>Current Password</label>
                                                <input
                                                type="text"
                                                name="current_password"
                                                value={values.current_password}
                                                className={
                                                    errors.current_password
                                                    ? "form-input form-control input-error"
                                                    : "form-input form-control"
                                                }
                                                onChange={(e) => {
                                                    handleChange(e);
                                                    customHandleInput(e);
                                                }}  onBlur={handleBlur}
                                                />
                                                <small>
                                                {backendErrors.current_password && (
                                                    <span className="form-error mt-1">
                                                    {backendErrors.current_password}
                                                    </span>
                                                )}
                                                </small>
                                            </div>
                                        </div>


                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <label>Password</label>
                                                <input
                                                type="text"
                                                name="password"
                                                value={values.password}
                                                className={
                                                    errors.password
                                                    ? "form-input form-control input-error"
                                                    : "form-input form-control"
                                                }
                                                onChange={(e) => {
                                                    handleChange(e);
                                                    customHandleInput(e);
                                                }}  onBlur={handleBlur}
                                                />
                                                <small>
                                                {backendErrors.password && (
                                                    <span className="form-error mt-1">
                                                    {backendErrors.password}
                                                    </span>
                                                )}
                                                </small>
                                            </div>
                                        </div>
                                        <div className="col-md-12">
                                                <div className="form-group">
                                                <label>Confirm Password</label>
                                                <input
                                                type="text"
                                                name="password_confirmation"
                                                value={values.password_confirmation}
                                                className={
                                                    errors.password_confirmation
                                                    ? "form-input form-control input-error"
                                                    : "form-input form-control"
                                                }
                                                onChange={(e) => {
                                                    handleChange(e);
                                                    customHandleInput(e);
                                                }} 
                                                onBlur={handleBlur}
                                                />
                                                <small>
                                                {backendErrors.password_confirmation  && (
                                                    <span className="form-error mt-1">
                                                        {backendErrors.password_confirmation}
                                                    </span>
                                                    )}
                                                </small>
                                            </div>
                                        </div>
                                        </div>
                                           
                                      
                                        <small>
                                            {/* {backendSuccess && (
                                                <div className="from-success mt-1">
                                                {backendSuccess}
                                                </div>
                                            )} */}
                                            {backendErrors.status  && (
                                                    <span className="form-error mt-1">
                                                    {backendErrors.status}
                                                    </span>
                                                )}
                                                {backendErrors.error  && (
                                                        <span className="form-error mt-1">
                                                        {backendErrors.error}
                                                        </span>
                                                    )}
                                        </small>
                                                            <div className="text-end">
                                                <button type="submit" id="form-submit" className="btn btn-primary">Update</button>
                                            </div>
                                        </form>
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
        );
    
}
export default ChangePassword;